import React, { useState } from "react";
import { inject, observer } from "mobx-react";
import {
  Button,
  Glyphicon,
  OverlayTrigger,
  Popover,
  Modal,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import { Link, NavLink } from "react-router-dom";
import { CustomTooltip } from "../tooltip/CustomTooltip";
import moment from "moment";
import { IoIosLink } from "react-icons/io";
import { TfiNewWindow } from "react-icons/tfi";
import { AiOutlineClose } from "react-icons/ai";
import toastService from "../../services/ToastService";
import { TrMarkdownModal } from "../../modal-views/TR-view-modal";
import { StoreContext } from "../../contexts/StoreContext";
import FullProfileComponent from "../navigation/FullProfileComponent";
import MaintenanceAgencyLabel from "./MaintenanceAgencyLabel";
import {
  FRAMEWORK_UPDATE_DESCRIPTIONS,
  labelForClassifications,
  labelForLegalReference,
} from "../../constants/constants-container";

const IS_BIRD_APP = process.env.REACT_APP_ENV === "bird";
@inject(
  "searchStore",
  "detailViewStore",
  "previewStore",
  "navigationStore",
  "popupStore"
)
@observer
export class DescriptiveMetaData extends React.Component {
  refDateLengthLimit = 10;

  constructor(props) {
    super(props);

    this.state = {
      version: null,
      referenceDate: null,
      showAll: false,
      showTr: false,
      frameworkChanges: {},
    };
    this.toggleVersion = this.toggleVersion.bind(this);
  }

  async componentDidMount() {
    const { versionsOfObject: versions } = this.props;
    const { tid, type } = this.props.object;
    if (versions && versions.length) {
      const firstVersion = versions.find((version) => version.tid === tid);
      this.toggleVersion(firstVersion);
    }

    if (!IS_BIRD_APP && type === "Framework") {
      const frameworkId = this.props.object.frameworkId;
      this.setState({
        frameworkChanges: await this.props.detailViewStore.getFrameworkChanges(
          frameworkId
        ),
      });
    }
  }

  toggleVersion = (version) => {
    if (version) {
      this.setState({
        version,
      });
    }
  };

  toggleTrModal = (value) => {
    value
      ? this.setState({ showTr: value })
      : this.setState({ showTr: !this.state.showTr });
  };

  toggleShowAll = () => {
    this.setState({ showAll: !this.state.showAll });
  };

  handleRefDateChange = (date) => {
    const { object } = this.props;
    this.setState({ referenceDate: date });
    this.context.setType(object.type);
    this.context.setTid(object.tid);
    this.context.setValidityDate(date, "YYYY-MM-DD");
  };

  getCubeTypeLabel = (type) => {
    if (!type) {
      return "";
    }
    switch (type.toLowerCase()) {
      case "c":
        return "Collection";
      case "d":
        return "Dissemination";
      case "eil":
        return "Enriched Input Layer";
      case "fl":
        return "Feedback Loop";
      case "il":
        return "Input Layer";
      case "nrc":
        return "Non-Reference Cube";
      case "rc":
        return "Reference Cube";
      case "s":
        return "Staging";
      case "d_as":
        return "Dissemination Analytical System";
      case "d_disc":
        return "Dissemination DISC";
      case "ldm":
        return "Logical Data Model";
      default:
        return "Uncommon cube type";
    }
  };

  getUrlForCopy = () => {
    const urlParts = window.location.href.split("?");
    const urlParams = urlParts.length > 1 ? "?" + urlParts[1] : "";
    const objectLinkForCopy =
      this.context.getEntityData?.item?.objectLink !== null
        ? window.location.origin +
          this.context.getEntityData.item.objectLink +
          urlParams
        : window.location.href;

    return encodeURI(objectLinkForCopy);
  };

  getUrlForOpen = (currentFrameworkName) => {
    const { searchFramework } = this.props.searchStore;
    let objectLinkForOpen = "/view/";
    if (currentFrameworkName) {
      const { getFrameworks } = this.props.searchStore;
      if (currentFrameworkName.tid) {
        return objectLinkForOpen + `Framework/${currentFrameworkName.tid}`;
      }
      if (!currentFrameworkName.name) {
        return "/";
      }
      let currentFrameworkTid = getFrameworks.find(
        (item) => item.name === currentFrameworkName.name
      );
      if (currentFrameworkTid && currentFrameworkTid.tid) {
        objectLinkForOpen += "Framework/" + currentFrameworkTid.tid;
      }
      return objectLinkForOpen;
    }
    objectLinkForOpen =
      this.context.getEntityData?.item?.object !== null
        ? objectLinkForOpen +
          this.context.getEntityData.item.object.type +
          "/" +
          this.context.getEntityData.item.object.tid
        : window.location.href;
    const params = new URLSearchParams(window.location.search);

    if (
      this.context.getEntityData.item.object.type.toLowerCase() ===
        "variable" &&
      searchFramework &&
      searchFramework.code
    ) {
      objectLinkForOpen += `?framework=${searchFramework.code}`;
    } else if (params.get("framework")) {
      let selectedFramework = params.get("framework");
      objectLinkForOpen += `?framework=${selectedFramework}`;
    }
    return objectLinkForOpen;
  };

  renderMappedRefAndNonref = (otherInformation, type) => {
    const { clearEntityData } = this.props.previewStore;
    let refKey;
    let nonRefKey;
    if (type === "Cube") {
      refKey = "mappedReferenceCubes";
      nonRefKey = "mappedNonReferenceCubes";
    }
    if (type === "Combination") {
      refKey = "mappedReferenceCombinations";
      nonRefKey = "mappedNonReferenceCombinations";
    }
    if (!refKey || !nonRefKey) return;
    return (
      <p>
        {otherInformation[refKey] && otherInformation[refKey].length ? (
          <span>
            <b>{`Mapped Reference ${type}:`} </b>
            {otherInformation[refKey].map((item) => (
              <span key={item.tid}>
                <Link
                  onClick={() => {
                    clearEntityData();
                  }}
                  to={`/view/${item.type}/${item.tid}`}
                >
                  {item.name} ({item.code})
                </Link>
                <MaintenanceAgencyLabel
                  maintenanceAgencyId={item.maintenanceAgencyId}
                ></MaintenanceAgencyLabel>
              </span>
            ))}
          </span>
        ) : null}
        {otherInformation[nonRefKey] && otherInformation[nonRefKey].length ? (
          <span>
            <b>{`Mapped Non-Reference ${type}:`} </b>
            {otherInformation[nonRefKey].map((item) => (
              <span key={item.tid}>
                <Link
                  onClick={() => {
                    clearEntityData();
                  }}
                  to={`/view/${item.type}/${item.tid}`}
                >
                  {item.name} ({item.code})
                </Link>
                <MaintenanceAgencyLabel
                  maintenanceAgencyId={item.maintenanceAgencyId}
                ></MaintenanceAgencyLabel>
              </span>
            ))}
          </span>
        ) : null}
      </p>
    );
  };
  static contextType = StoreContext;

  renderFrameworkUpdatesInformations = () => {
    const dataModelPopover = (
      <Popover id="dataModel">
        {FRAMEWORK_UPDATE_DESCRIPTIONS.LAST_DATA_MODEL_UPDATE}
      </Popover>
    );
    const contentPopover = (
      <Popover id="content">
        {FRAMEWORK_UPDATE_DESCRIPTIONS.LAST_CONTENT_UPDATE}
      </Popover>
    );
    return (
      <>
        <p>
          <b>
            Latest data model update{" "}
            {this.getOverlayTriggerWithPopOver(dataModelPopover)} :
          </b>{" "}
          {this.state.frameworkChanges.messageToDisplayIfError ??
            this.state.frameworkChanges?.lastDataModelUpdateWhen}
        </p>
        <p>
          <b>
            Latest content or validation update{" "}
            {this.getOverlayTriggerWithPopOver(contentPopover)} :
          </b>{" "}
          {this.state.frameworkChanges.messageToDisplayIfError ??
            this.state.frameworkChanges?.lastContentUpdateWhen}
        </p>
      </>
    );
  };

  getOverlayTriggerWithPopOver = (popover) => {
    return (
      <OverlayTrigger overlay={popover} placement="bottom" rootClose>
        <span>
          <Glyphicon glyph="info-sign" />
        </span>
      </OverlayTrigger>
    );
  };

  getOverlayTriggerWithPopOverTags = (popover) => {
    return (
      <OverlayTrigger overlay={popover} placement="bottom" rootClose>
        <span>test</span>
      </OverlayTrigger>
    );
  };

  render() {
    const {
      versionsOfObject: versions,
      object: { type, maintenanceAgencyId, tid },
      searchStore: { getMetadata },
      definedOn,
      otherInformation,
      referenceDates,
      navigationLookupResult: lookupResult,
    } = this.props;
    const { clearEntityData, setCanRefresh } = this.context;
    const { closeSpecificTab } = this.props.navigationStore;
    const { csiDescriptionField } = this.props.popupStore;

    const metadata = getMetadata[type];
    const {
      version: currentVersion,
      referenceDate,
      showAll,
      showTr,
    } = this.state;
    let prevVersion = null,
      nextVersion = null,
      currentVersionIndex = null,
      dateRange = null;

    const maintenanceAgencyName =
      (this.props.otherInformation &&
        this.props.otherInformation.maintenanceAgency &&
        this.props.otherInformation.maintenanceAgency.length > 0 &&
        this.props.otherInformation.maintenanceAgency[0].name) ||
      "";

    const entityDataItem = this.context.getEntityData.item;
    const hasTransformationRules =
      entityDataItem &&
      entityDataItem.otherInformation &&
      entityDataItem.otherInformation.transformationRules &&
      entityDataItem.otherInformation.transformationRules[0]
        ? true
        : false;
    const hasLegalTexts =
      entityDataItem &&
      entityDataItem.legalInfos &&
      entityDataItem.legalInfos.LegalText &&
      entityDataItem.legalInfos.LegalText[0]
        ? true
        : false;
    const hasClassifications =
      entityDataItem &&
      entityDataItem.legalInfos &&
      entityDataItem.legalInfos.Classification &&
      entityDataItem.legalInfos.Classification[0]
        ? true
        : false;
    const hasLegalReference =
      entityDataItem &&
      entityDataItem.legalInfos &&
      entityDataItem.legalInfos.LegalReference &&
      entityDataItem.legalInfos.LegalReference[0]
        ? true
        : false;

    if (currentVersion && versions && versions.length) {
      currentVersionIndex = versions.findIndex(
        (v) => v.validFrom === currentVersion.validFrom
      );
      prevVersion = versions[currentVersionIndex - 1] || null;
      nextVersion = versions[currentVersionIndex + 1] || null;
      dateRange = `${moment(currentVersion.validFrom).format(
        "DD.MM.YYYY"
      )} - ${moment(currentVersion.validTo).format("DD.MM.YYYY")}`;
    }

    const data = this.props.object;

    if (
      IS_BIRD_APP &&
      data.type?.toLowerCase() === "framework" &&
      !this.context.shouldDisplayPublishedCubesOfFramework
    ) {
      data.name += " (Cubes not yet in the BIRD)";
    }

    let mappingDefVariables = () => {
      let sddVariablesMap = new Map();
      if (
        !lookupResult.navigationLookupRootItem ||
        !lookupResult.navigationLookupRootItem.items
      ) {
        return null;
      }
      const variableMappings = lookupResult.navigationLookupRootItem.items;
      variableMappings.forEach((variableMapping) => {
        if (!variableMapping.items) {
          return null;
        }
        const variableMappingItems = variableMapping.items;
        variableMappingItems.forEach((variableMappingItem) => {
          if (!variableMappingItem.items) {
            return null;
          }
          variableMappingItem.items.forEach((sddVariable) => {
            if (variableMappingItem.object.isSource === true) {
              sddVariablesMap.set(
                "input",
                sddVariable.object.name + " (" + sddVariable.object.code + ")"
              );
            } else {
              sddVariablesMap.set(
                "output",
                sddVariable.object.name + " (" + sddVariable.object.code + ")"
              );
            }
          });
        });
      });
      return sddVariablesMap;
    };

    // cube - data set distributions from DI
    let dataSetDistributionComponents = [];
    if (otherInformation && otherInformation["dataSetDistributions"]) {
      const dataSetDistributions = otherInformation["dataSetDistributions"];
      const filteredDataSetDistributions = dataSetDistributions.filter(
        (distribution) => distribution.name
      );
      if (
        filteredDataSetDistributions &&
        filteredDataSetDistributions.length > 0
      ) {
        const dataDownloadUrlsComponents = [];
        const dataDiscTablesLinksComponents = [];

        filteredDataSetDistributions.forEach((distribution, index, array) => {
          // after DI 2.3
          if (
            distribution.dataDownloadUrls &&
            distribution.dataDownloadUrls.length > 0
          ) {
            distribution.dataDownloadUrls.forEach(
              (dataDownloadUrl, index, array) => {
                dataDownloadUrlsComponents.push(
                  <a
                    key={dataDownloadUrl}
                    href={dataDownloadUrl}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {dataDownloadUrl.length > 80
                      ? dataDownloadUrl.substring(0, 80) + "..."
                      : dataDownloadUrl}
                  </a>
                );
                if (index < array.length - 1)
                  dataDownloadUrlsComponents.push(<span>{", "}</span>);
              }
            );
          }
          if (
            distribution.dataDiscTables &&
            distribution.dataDiscTables.length !== 0
          ) {
            const discTablesListItems = [];

            const featureToggleInlineStyle = true;

            distribution.dataDiscTables
              .filter((dataDiscTable) => true) // possibility to extend by filtering based on bindings if data:metadata is stored in m:n fashion
              .forEach((dataDiscTable, index, array) => {
                if (featureToggleInlineStyle) {
                  dataDiscTablesLinksComponents.push(
                    <a
                      href={dataDiscTable.tableUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {dataDiscTable.databaseName +
                        "." +
                        dataDiscTable.tableName}
                    </a>
                  );
                  if (index < array.length - 1)
                    dataDiscTablesLinksComponents.push(<span>{", "}</span>);
                } else {
                  discTablesListItems.push(
                    <li key={dataDiscTable.datasetCode}>
                      {
                        <a
                          href={dataDiscTable.tableUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {dataDiscTable.databaseName +
                            "." +
                            dataDiscTable.tableName}
                        </a>
                      }
                    </li>
                  );
                }
              });
            if (!featureToggleInlineStyle) {
              dataDiscTablesLinksComponents.push(
                <ul>{discTablesListItems}</ul>
              );
            }
          }
          // before DI 2.3
          if (distribution.downloadUrl) {
            // TODO is URL sanitized?
            if (dataDownloadUrlsComponents.length !== 0) {
              dataDownloadUrlsComponents.push(<span>{", "}</span>);
            }
            dataDownloadUrlsComponents.push(
              <span>
                <a
                  href={distribution.downloadUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  {distribution.downloadUrl.length > 80
                    ? distribution.downloadUrl.substring(0, 80) + "..."
                    : distribution.downloadUrl}
                </a>{" "}
                (may be obsolete)
              </span>
            );
          }
          if (
            distribution.discTables &&
            distribution.discTables.discDBsAndTables &&
            distribution.discTables.discDBsAndTables.length !== 0
          ) {
            const discTablesMap = distribution.discTables.discDBsAndTables;
            const discTablesListItems = [];

            Object.keys(discTablesMap).forEach((key) => {
              discTablesListItems.push(
                discTablesMap[key].map((link, index) => {
                  return (
                    <li key={index}>
                      {
                        <a href={link} target="_blank" rel="noreferrer">
                          {link.length > 80
                            ? link.substring(0, 80) + "..."
                            : link}
                        </a>
                      }{" "}
                      (may be obsolete)
                    </li>
                  );
                })
              );
            });
            dataDiscTablesLinksComponents.push(<ul>{discTablesListItems}</ul>);
          }

          dataSetDistributionComponents.push(
            <div className="dataSetDistributions">
              <hr />
              <p key="distributions">
                <b>Data Set Distribution in Data Inventory: </b>{" "}
                {distribution.name}
              </p>
              {dataDownloadUrlsComponents.length !== 0 ? (
                <p key="dataDownloadUrls">
                  <b>
                    Data Download URL
                    {dataDownloadUrlsComponents.length > 1 ? `s` : ``}:{" "}
                  </b>{" "}
                  {dataDownloadUrlsComponents}
                </p>
              ) : (
                ""
              )}
              {dataDiscTablesLinksComponents.length !== 0 ? (
                <p key="dataDiscTables">
                  <b>
                    DISC Table
                    {dataDiscTablesLinksComponents.length > 1 ? `s` : ``}:{" "}
                  </b>{" "}
                  {dataDiscTablesLinksComponents}
                </p>
              ) : (
                ""
              )}
            </div>
          );
        });
      }
    }

    const DatePickerButton = ({ value, onClick }) => (
      <Button onClick={onClick}>
        <Glyphicon glyph="calendar" /> {value}
      </Button>
    );

    const datasetUrlAttr =
      !IS_BIRD_APP && type === "Cube" && data.datasetUrl ? (
        <p>
          <b>Dataset URL: </b>
          <a href={data.datasetUrl} target="_blank" rel="noreferrer">
            {data.datasetUrl.length > 80
              ? data.datasetUrl.substring(0, 80) + "..."
              : data.datasetUrl}
          </a>
        </p>
      ) : null;

    const { getFrameworks, searchFramework, getSelectedFramework } =
      this.props.searchStore;

    let refFramework = undefined;
    if (
      this.props.object.type === "Framework" &&
      !this.props.object.code.includes("_REF")
    ) {
      const currentFramework = this.props.object;
      const frameworks = getFrameworks;
      refFramework = frameworks.find(
        (it) =>
          it.code.includes(currentFramework.code) && it.code.includes("_REF")
      );
    }

    let nonRefFramework = undefined;
    if (
      this.props.object.type === "Framework" &&
      this.props.object.code.includes("_REF")
    ) {
      const currentFramework = this.props.object;
      const frameworks = getFrameworks;
      nonRefFramework = frameworks.find(
        (it) =>
          currentFramework.code.includes(it.code) && !it.code.includes("_REF")
      );
    }
    let currentFramework = getFrameworks.find(
      (element) => element.frameworkId === this.props.object.frameworkId
    );
    if (!currentFramework) {
      currentFramework = {};
      currentFramework.name = searchFramework?.name;
      if (
        !searchFramework &&
        getSelectedFramework &&
        getSelectedFramework.name
      ) {
        currentFramework.name = getSelectedFramework.name;
      } else {
        const params = new URLSearchParams(window.location.search);
        if (params.get("framework")) {
          const frameworks = getFrameworks;
          let frameworkName = frameworks.find(
            (it) => it.code === params.get("framework")
          );
          currentFramework.name = frameworkName?.name;
        }
      }
    }

    const renderPrimaryVariableInformations = (primaryConcept, buckets) => {
      if (
        !primaryConcept ||
        !buckets ||
        !buckets["Primary Variables"] ||
        !buckets["Primary Variables"].objects?.length
      )
        return;
      const primaryVariable = buckets["Primary Variables"].objects.find(
        (pv) => pv.variableId === primaryConcept
      );
      return !!primaryVariable ? (
        <p>
          <b>More generic Variable: </b>
          <a href={`/view/Variable/${primaryVariable.tid}`}>
            {primaryVariable.name}
          </a>
          ({primaryVariable.code})
        </p>
      ) : (
        ""
      );
    };

    return (
      <>
        {this.context.type &&
        (this.context.type === "CubeHierarchy" ||
          this.context.type === "Cube" ||
          this.context.type === "Variable") ? (
          <div className="breadcrums-container">
            {currentFramework &&
            currentFramework.name &&
            currentFramework.name !== "All applicable Frameworks" ? (
              <Link
                onClick={() => {
                  clearEntityData();
                  setCanRefresh(true);
                }}
                to={this.getUrlForOpen(currentFramework)}
              >
                {currentFramework?.name || "All applicable Frameworks"}{" "}
              </Link>
            ) : (
              currentFramework?.name || "All applicable Frameworks"
            )}{" "}
            /{" "}
            {
              <Link
                onClick={() => {
                  clearEntityData();
                  setCanRefresh(true);
                }}
                to={this.getUrlForOpen()}
              >
                {data["name"]}{" "}
              </Link>
            }
          </div>
        ) : (
          //used To align Framework panel with right panel, asked in SDD-1065 comment
          <div className="breadcrums-container">
            <div> &nbsp;</div>
          </div>
        )}
        <div className="descriptive-metadata custom-panel">
          <div
            className={`custom-panel-heading ${
              maintenanceAgencyId && maintenanceAgencyId === "ECB"
                ? "reference"
                : "non-reference"
            }`}
          >
            <h4>
              {type === "CubeHierarchy"
                ? "Data Model"
                : metadata.labelForType || type}
            </h4>

            <CustomTooltip
              type={type}
              placement={
                this.context === this.props.previewStore ? "left" : "right"
              }
            />
            <div
              style={{
                display: "flex",
                marginLeft: "auto",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {this.context !== this.props.detailViewStore && (
                <OverlayTrigger
                  placement="left"
                  overlay={
                    <Popover id={"Goto-icon"}>{"Open this Tab"}</Popover>
                  }
                >
                  <span
                    style={{
                      fontSize: "17px",
                      cursor: "pointer",

                      marginInline: "5px",
                    }}
                  >
                    <Link
                      style={{
                        color: maintenanceAgencyId === "ECB" ? "white" : "#333",
                      }}
                      to={this.getUrlForOpen()}
                      target="_blank"
                    >
                      <TfiNewWindow></TfiNewWindow>
                    </Link>
                  </span>
                </OverlayTrigger>
              )}
              <OverlayTrigger
                placement="left"
                overlay={<Popover id={"copy-icon"}>{"Copy link"}</Popover>}
              >
                <span
                  style={{
                    fontSize: "18px",
                    cursor: "pointer",
                    marginInline: "5px",
                    paddingTop: "4px",
                  }}
                >
                  <IoIosLink
                    onClick={() => {
                      navigator.clipboard.writeText(this.getUrlForCopy());
                      toastService.func_notify("Link copied to clipboard");
                    }}
                  ></IoIosLink>
                </span>
              </OverlayTrigger>

              {this.context !== this.props.detailViewStore &&
                (this.context === this.props.popupStore &&
                !this.props.popupStore.closeButton ? (
                  <></>
                ) : (
                  <span
                    style={{
                      cursor: "pointer",
                      marginInline: "5px",
                      fontSize: "18px",
                      fontWeight: "bold",
                    }}
                  >
                    <AiOutlineClose
                      onClick={() => {
                        if (this.context !== this.props.popupStore)
                          clearEntityData();
                        setCanRefresh(true);
                        closeSpecificTab(tid);
                      }}
                    ></AiOutlineClose>
                  </span>
                ))}
            </div>
          </div>
          <div className="custom-panel-body">
            {metadata.fieldsForDescriptiveMetadataSection.map(
              (field, index) => {
                return (
                  <p
                    key={index}
                    style={{
                      maxWidth: "calc(100% - 130px)",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    <b>{metadata.labelsForFields[field]}: </b>{" "}
                    {data[field] || "-"}
                  </p>
                );
              }
            )}

            {this.context === this.props.popupStore && type === "Variable" && (
              <>
                {csiDescriptionField && csiDescriptionField !== "" && (
                  <p
                    style={{
                      maxWidth: "calc(100% - 130px)",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    <b>In the context of this Cube: </b>
                    {csiDescriptionField}
                  </p>
                )}
              </>
            )}

            {maintenanceAgencyId ? (
              <p>
                <b>Maintenance agency:</b>{" "}
                {`${maintenanceAgencyName} (${maintenanceAgencyId})`}
              </p>
            ) : (
              ""
            )}

            {type === "Framework" && refFramework ? (
              <p>
                <b>Reference Framework:</b>
                <Link
                  key="title-name"
                  className="object-name"
                  to={`/view/${refFramework.type}/${refFramework.tid}`}
                >
                  {refFramework.name}
                </Link>
                {` (${refFramework.code}) `}
              </p>
            ) : (
              ""
            )}

            {type === "Framework" && nonRefFramework ? (
              <p>
                <b>Non-Reference Framework:</b>
                <Link
                  key="title-name"
                  className="object-name"
                  to={`/view/${nonRefFramework.type}/${nonRefFramework.tid}`}
                >
                  {nonRefFramework.name}
                </Link>
                {` (${nonRefFramework.code}) `}
              </p>
            ) : (
              ""
            )}

            {type === "Cube" && data.cubeType ? (
              <p>
                <b>Type of cube:</b> {data.cubeType} -{" "}
                {this.getCubeTypeLabel(data.cubeType)}
              </p>
            ) : (
              ""
            )}
            {type === "Variable" && data.primaryConcept
              ? renderPrimaryVariableInformations(
                  data.primaryConcept,
                  this.props.navigationLookupResult?.navigationLookupBuckets
                )
              : ""}
            {hasTransformationRules && type === "Variable" && (
              <>
                <span>
                  <p>
                    <b>How to derive this Variable: </b>
                    <Link
                      style={{ cursor: "pointer" }}
                      onClick={() => this.toggleTrModal(true)}
                    >
                      Semantic transformation rule
                    </Link>
                  </p>
                </span>

                <TrMarkdownModal
                  show={showTr}
                  toggleTrModal={this.toggleTrModal}
                  name={data["name"]}
                ></TrMarkdownModal>
              </>
            )}

            {hasTransformationRules && type === "Cube" && (
              <>
                <span>
                  <p>
                    <b>How to generate this Cube: </b>
                    <Link
                      style={{ cursor: "pointer" }}
                      onClick={() => this.toggleTrModal(true)}
                    >
                      Semantic transformation rule
                    </Link>
                  </p>
                </span>

                <TrMarkdownModal
                  show={showTr}
                  toggleTrModal={this.toggleTrModal}
                  name={data["name"]}
                ></TrMarkdownModal>
              </>
            )}

            {definedOn &&
            definedOn.length &&
            this.context === this.props.detailViewStore
              ? definedOn.map((item, index) => {
                  const itemObj = item.object;
                  let itemUrl = `/view/${itemObj.type}/${itemObj.tid}`;
                  if (
                    itemObj.type?.toLowerCase() === "framework" &&
                    IS_BIRD_APP
                  ) {
                    itemUrl = data?.published
                      ? `/view/${itemObj.type}/${itemObj.tid}?published=true`
                      : `/view/${itemObj.type}/${itemObj.tid}?published=false`;
                  }
                  const itemFields =
                    getMetadata[itemObj.type].fieldsForSearchResultView;
                  const titleItems = [];

                  if (itemObj.type === "FacetCollection") {
                    const nameField = itemFields.find((x) =>
                      x.toLowerCase().includes("name")
                    );
                    if (nameField) {
                      titleItems.push(
                        <Link
                          key="title-name"
                          className="object-name"
                          to={itemUrl}
                        >
                          <span>{itemObj[nameField]}</span>
                        </Link>
                      );
                    }
                    return (
                      <p key={index}>
                        <b>Is defined on Facet: </b>
                        {titleItems}
                      </p>
                    );
                  } else {
                    const nameField = itemFields.find((x) =>
                      x.toLowerCase().includes("name")
                    );
                    if (nameField) {
                      titleItems.push(
                        <Link
                          key="title-name"
                          className="object-name"
                          to={itemUrl}
                        >
                          {itemObj[nameField]}
                        </Link>
                      );
                    }
                    const legalCodeField = itemFields.find((x) =>
                      x.includes("legalCode")
                    );
                    if (legalCodeField) {
                      titleItems.push(
                        <Link
                          key="title-legalCode"
                          className="object-name"
                          to={itemUrl}
                        >
                          {itemObj[legalCodeField]}
                        </Link>
                      );
                    }
                    const codeField = itemFields.find((x) =>
                      x.includes("code")
                    );
                    if (codeField) {
                      titleItems.push(`(${itemObj[codeField]})`);
                    }
                    // titleItems.push(<Label key='title-type' className='object-type' bsStyle='success'>{itemObj.type}</Label>)
                    if (itemObj.maintenanceAgencyId) {
                      titleItems.push(
                        <MaintenanceAgencyLabel
                          maintenanceAgencyId={itemObj.maintenanceAgencyId}
                        ></MaintenanceAgencyLabel>
                      );
                    }

                    return (
                      <>
                        {type !== "Cube" && (
                          <p key={index}>
                            <b>Is defined on {itemObj.type}: </b>
                            {titleItems}
                          </p>
                        )}
                      </>
                    );
                  }
                })
              : ""}

            {type === "Variable" && !data.isDecomposed ? (
              <p>
                <b>This Variable is not decomposed</b>
              </p>
            ) : (
              ""
            )}

            {referenceDates && referenceDates.length ? (
              <div>
                <hr></hr>
                <p className="reference-dates-array">
                  <b>Significant reference dates: </b>
                  {referenceDates
                    .filter((rd, index) =>
                      showAll ? true : index <= this.refDateLengthLimit
                    )
                    .map((rd) => {
                      const formattedRefDate = rd
                        ? moment(rd, "YYYY-MM-DD").format("YYYY-MM-DD")
                        : null;
                      return (
                        <NavLink
                          key={formattedRefDate}
                          isActive={() => formattedRefDate === referenceDate}
                          to={`/view/${data.type}/${data.tid}`}
                          activeClassName="selected"
                          onClick={(event) => {
                            event.preventDefault();
                            this.handleRefDateChange(formattedRefDate);
                          }}
                        >
                          {formattedRefDate}
                        </NavLink>
                      );
                    })}
                  {referenceDates.length > this.refDateLengthLimit ? (
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    <a
                      className="show-all-toggle"
                      href=""
                      onClick={(event) => {
                        event.preventDefault();
                        this.toggleShowAll();
                      }}
                    >
                      {showAll ? "Show less" : "... Show all"}
                    </a>
                  ) : null}
                </p>
                <div>
                  <b>Reference date for Related : </b>
                  <DatePicker
                    dateFormat="yyyy-MM-dd"
                    selected={this.context.getValidityDate || null}
                    onChange={(date) => {
                      const { object } = this.props;
                      this.context.setType(object.type);
                      this.context.setTid(object.tid);
                      this.context.setValidityDate(date);
                      this.setState({ referenceDate: date });
                    }}
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    // isClearable
                    customInput={<DatePickerButton />}
                  />
                </div>
              </div>
            ) : null}

            {versions && versions.length && currentVersion ? (
              <p className="versions">
                <b>
                  {`${metadata.versionable ? "Version" : "Reference date"}`}:
                </b>{" "}
                {!prevVersion ? (
                  <span className={`toggle ${!prevVersion ? "disabled" : ""}`}>
                    <Glyphicon glyph="chevron-left" />
                  </span>
                ) : (
                  <Link
                    onClick={(e) => {
                      if (this.context !== this.props.detailViewStore)
                        e.preventDefault();
                      this.context.setType(prevVersion.type);
                      this.context.setTid(prevVersion.tid);
                    }}
                    // className={"toggle"}
                    to={`/view/${prevVersion.type}/${prevVersion.tid}`}
                  >
                    <Glyphicon glyph="chevron-left" />
                  </Link>
                )}
                <span className="current-version">
                  {metadata.versionable
                    ? currentVersion.version
                    : dateRange || "-"}
                </span>
                {!nextVersion ? (
                  <span className={`toggle ${!nextVersion ? "disabled" : ""}`}>
                    <Glyphicon glyph="chevron-right" />
                  </span>
                ) : (
                  <Link
                    onClick={(e) => {
                      if (this.context !== this.props.detailViewStore)
                        e.preventDefault();
                      this.context.setType(nextVersion.type);
                      this.context.setTid(nextVersion.tid);
                    }}
                    // className={"toggle"}
                    to={`/view/${nextVersion.type}/${nextVersion.tid}`}
                  >
                    <Glyphicon glyph="chevron-right" />
                  </Link>
                )}
                {metadata.versionable ? <span>({dateRange})</span> : ""}
              </p>
            ) : (
              ""
            )}
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              {hasLegalReference && <b>Legal References:</b>}
              {hasLegalTexts &&
              entityDataItem.legalInfos.LegalText.length > 1 ? (
                <>
                  {entityDataItem.legalInfos.LegalText?.map((legaltext) => {
                    return (
                      <HoverTextComponent
                        key={legaltext.legalTextId}
                        typeOfContent={"Legal reference"}
                        buttonText={legaltext.legalDescription}
                        hoverText={legaltext}
                        article={findLegalReferencesArticles(
                          hasLegalReference,
                          legaltext.legalTextId,
                          this.context
                        )}
                      />
                    );
                  })}
                </>
              ) : hasLegalTexts ? (
                <>
                  <HoverTextComponent
                    typeOfContent={"Legal reference"}
                    buttonText={
                      entityDataItem.legalInfos.LegalText[0].legalDescription
                    }
                    hoverText={entityDataItem.legalInfos.LegalText[0]}
                    article={findLegalReferencesArticles(
                      hasLegalReference,
                      entityDataItem.legalInfos.LegalText[0].legalTextId,
                      this.context
                    )}
                  />
                </>
              ) : null}
            </div>
            <div
              style={{
                display: "flex",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              {hasClassifications && <b>Classifications:</b>}
              {hasClassifications &&
              entityDataItem.legalInfos.Classification.length > 1 ? (
                <>
                  {entityDataItem.legalInfos.Classification?.map(
                    (classification) => {
                      return (
                        <HoverTextComponent
                          key={classification.name}
                          typeOfContent={"Classification"}
                          buttonText={classification.name}
                          hoverText={classification}
                        />
                      );
                    }
                  )}
                </>
              ) : hasClassifications ? (
                <>
                  <HoverTextComponent
                    typeOfContent={"Classification"}
                    buttonText={
                      entityDataItem.legalInfos.Classification[0].name
                    }
                    hoverText={entityDataItem.legalInfos.Classification[0]}
                  />
                </>
              ) : null}
            </div>

            {(type === "Cube" || type === "Combination") && otherInformation ? (
              <React.Fragment>
                {this.renderMappedRefAndNonref(otherInformation, type) || null}
              </React.Fragment>
            ) : null}

            {type === "MappingDefinition" && data.mappingType ? (
              <p>
                <b>Mapping type:</b> {data.mappingType}
              </p>
            ) : (
              ""
            )}

            {type === "MappingDefinition" && data.mappingType === "A" ? (
              <p>
                <b>Non-Reference:</b> {mappingDefVariables().get("input")}
              </p>
            ) : (
              ""
            )}
            {type === "MappingDefinition" && data.mappingType === "A" ? (
              <p>
                <b>Reference:</b> {mappingDefVariables().get("output")}
              </p>
            ) : (
              ""
            )}

            {datasetUrlAttr}

            {dataSetDistributionComponents ? dataSetDistributionComponents : ""}

            {!IS_BIRD_APP &&
              type === "Framework" &&
              this.renderFrameworkUpdatesInformations()}
            <FullProfileComponent
              type={type}
              shouldDisplay={!this.context.getDisplayFullProfilTips}
              shoulPageReload={true}
              selectedUserProfileId={
                this.props.searchStore.getSelectedUserProfile.id
              }
            ></FullProfileComponent>
          </div>
        </div>
      </>
    );
  }
}

const findLegalReferencesArticles = (
  hasLegalReference,
  legalTextId,
  context
) => {
  if (hasLegalReference) {
    return context.getEntityData.item.legalInfos.LegalReference.filter(
      (a) => a.legalTextId === legalTextId
    ).map((a) => a.article);
  }
  return [];
};
function HoverTextComponent({
  typeOfContent,
  buttonText,
  hoverText,
  article = null,
}) {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    setShowModal(!showModal);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const labelsToShow =
    typeOfContent === "Classification"
      ? labelForClassifications
      : typeOfContent === "Legal reference"
      ? labelForLegalReference
      : [];

  return (
    <div style={{ display: "inline-block" }}>
      <span style={hashtagStyle} onClick={handleClick}>
        #{buttonText}
      </span>
      <Modal
        show={showModal}
        onHide={handleClose}
        dialogClassName="VariableDetailsModal related-types-list cube-structure-item"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>{buttonText}</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <div className="descriptive-metadata custom-panel">
            <div
              className={`custom-panel-heading 
                 reference
            `}
            >
              <h4>{typeOfContent}</h4>
            </div>
            <div className="custom-panel-body">
              {hoverText && (
                <>
                  {labelsToShow.map(
                    ({ label, value }) =>
                      hoverText[label] !== undefined && (
                        <div key={label} style={modalTextStyle}>
                          <strong>{value}:</strong>{" "}
                          {label === "hyperlink" && hoverText[label] ? (
                            <a
                              href={hoverText[label]}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={modalLinkStyle}
                            >
                              {hoverText[label]}
                            </a>
                          ) : (
                            hoverText[label]?.toString() || ""
                          )}
                        </div>
                      )
                  )}
                </>
              )}

              {article &&
                article?.map((text, index) => (
                  <div key={index} style={modalTextStyle}>
                    <strong>Article:</strong> {text}
                  </div>
                ))}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

const hashtagStyle = {
  color: "#003299",
  cursor: "pointer",
  fontSize: "10px",
  fontWeight: "bold",
  textDecoration: "none",
  transition: "color 0.2s ease",
};

const modalTextStyle = {
  marginBottom: "10px",
};

const modalLinkStyle = {
  color: "#003299",
  textDecoration: "underline",
  display: "block",
  marginBottom: "10px",
  cursor: "pointer",
};

class TextWrapper extends React.Component {
  wrapText(text, maxWidth) {
    const words = text.split(" ");
    let wrappedText = "";
    let line = "";

    for (let word of words) {
      if (line.length + word.length + 1 <= maxWidth) {
        line += (line.length ? " " : "") + word;
      } else {
        wrappedText += (wrappedText.length ? "\n" : "") + line;
        line = word;
      }
    }

    wrappedText += (wrappedText.length ? "\n" : "") + line;
    return wrappedText.split("\n").map(
      (line, index) =>
        line !== "" && (
          <span key={index}>
            {line}
            <br />
          </span>
        )
    );
  }

  render() {
    const { children, maxWidth } = this.props;

    const wrappedChildren = React.Children.map(children, (child) => {
      if (typeof child === "string") {
        return this.wrapText(child, maxWidth);
      } else if (
        React.isValidElement(child) &&
        typeof child.props.children === "string"
      ) {
        const wrappedText = this.wrapText(child.props.children, maxWidth);
        return React.cloneElement(child, {}, wrappedText);
      } else {
        return child;
      }
    });

    return (
      <React.Fragment
        style={{
          whiteSpace: "pre-wrap",
          width: `${maxWidth}ch`,
          lineHeight: "1.2",
        }}
      >
        {wrappedChildren}
      </React.Fragment>
    );
  }
}

export default TextWrapper;
